import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

class NavbarMini extends Component {
    constructor(props) {
        super(props);
        this.state = { selectedItem: '' };
    }

    //Check items array prop for specified active item
    componentWillMount() {
        this.props.items.forEach((item) => {
            if (item.isActive) {
                this.setState({ selectedItem: item.title });
            }
        });
    }

    updateSelectedItem(title) {
        this.setState({ selectedItem: title });
        this.props.items.forEach((item) => {
            if (item.title === this.state.selectedItem) {
                item.isActive = true;
            } else {
                item.isActive = false;
            }
        });
    }
    renderNavItem(item) {
        return (
            <li className="p-navbar-mini__nav-item" key={item.title}>
                <a
                    className={classNames(
                        'p-navbar-mini__nav-link',
                        'u-text-h5',
                        item.titleShort ? 'p-navbar-mini__nav-link-short' : ''
                    )}
                    href={item.url}
                    data-mobile-href={item.mobileUrl || ''}
                    onClick={() => this.updateSelectedItem(item.title)}
                    target="_self"
                >
                    {item.titleShort ? <span className="p-navbar-mini__title-short">{item.titleShort}</span> : ''}
                    <span className="p-navbar-mini__title">{item.title}</span>
                </a>
            </li>
        );
    }

    render() {
        return (
            <div className="p-navbar-mini" data-cid={this.props.contentId}>
                <ul className="p-navbar-mini__nav-list">{this.props.items.map((item) => this.renderNavItem(item))}</ul>
            </div>
        );
    }
}

NavbarMini.propTypes = {
    contentId: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string, url: PropTypes.string })).isRequired
};

NavbarMini.defaultProps = {
    contentId: undefined
};

export default NavbarMini;
